module.exports = __webpack_public_path__ + "static/media/update_profile.bec42790.svg";